import { createFeatureSelector } from '@ngrx/store';
import { FeatureState } from './feature.state';

export const FEATURE_NAME = 'core_invites';

export const featureState = createFeatureSelector<FeatureState>(FEATURE_NAME);
